module.exports = __webpack_public_path__ + "img/kooperativa.72760a10.png";